import { gql } from "@apollo/client";

export const getOpenDutiesQuery = gql`
  query GetOpenDuties($status: String!, $startDate: String, $endDate: String) {
    getOpenDuties(status: $status, startDate: $startDate, endDate: $endDate) {
      message
      response
    }
  }
`;


export const getTotalHourQuery = gql`
  query getTotalHour($startDate: String, $endDate: String) {
    getTotalHour(startDate: $startDate, endDate: $endDate) {
      message
      response
    }
  }
`;



export const getTotalguardingDutiesQuery = gql`
  query getTotalguardingDuties($startDate: String, $endDate: String) {
    getTotalguardingDuties(startDate: $startDate, endDate: $endDate) {
      message
      response
    }
  }
`;



export const getTotalDeployStaffQuery = gql `
  query getTotalDeployStaff($startDate: String, $endDate: String) {
    getTotalDeployStaff(startDate: $startDate, endDate: $endDate) {
      message
      response
    }
  }
`;


export const getAppUsageForDashboardQuery = gql `
  query getAppUsageForDashboard($startDate: String, $endDate: String) {
    getAppUsageForDashboard(startDate: $startDate, endDate: $endDate) {
      message
      response
    }
  }
`;



export const getPendingReportsForDashboardQuery = gql `
  query getPendingCheckpointsForDashboard($startDate: String, $endDate: String) {
    getPendingCheckpointsForDashboard(startDate: $startDate, endDate: $endDate) {
      message
      response
    }
  }
`;


export const getPendingTaskForDashboardQuery = gql `
  query getPendingTaskForDashboard($startDate: String, $endDate: String) {
    getPendingTaskForDashboard(startDate: $startDate, endDate: $endDate) {
      message
      response
    }
  }
`;


export const GetAppUserQuery = gql`
query GetAppUser {
  getAppUser {
      response
      message
  }
}
`;


export const getTotalguardingDutiesGraphQuery = gql`
query GetTotalGuardingDutiesGraph(
  $startDate: String!
  $endDate: String!
  $graphType: String!
) {
  getTotalguardingDutiesGraph(
    startDate: $startDate
    endDate: $endDate
    graphType: $graphType

  ) {
    message
    response
    
  }
}
`;


export const getActiveUserQuery = gql`
query GetActiveUser {
  getActiveUser {
    response
  }
}
`;


export const getActivityLogQuery = gql`
  query getActivityLog($startDate: String, $endDate: String, $page: Int, $pageSize: Int) {
    getActivityLog(startDate: $startDate, endDate: $endDate, page: $page, pageSize: $pageSize) {
      response
      totalCount
    }
  }
`;


// ── dashboard tile click-through detail lists ──

export const getScheduleDashboardDetailQuery = gql`
  query getScheduleDashboardDetail($ids: [String!]!, $page: Int, $pageSize: Int) {
    getScheduleDashboardDetail(ids: $ids, page: $page, pageSize: $pageSize) {
      response
      totalCount
    }
  }
`;

export const getEmployeeDashboardDetailQuery = gql`
  query getEmployeeDashboardDetail($ids: [String!]!, $page: Int, $pageSize: Int) {
    getEmployeeDashboardDetail(ids: $ids, page: $page, pageSize: $pageSize) {
      response
      totalCount
    }
  }
`;

export const getPendingTaskDetailQuery = gql`
  query getPendingTaskDetail($ids: [String!]!, $page: Int, $pageSize: Int) {
    getPendingTaskDetail(ids: $ids, page: $page, pageSize: $pageSize) {
      response
      totalCount
    }
  }
`;

export const getPendingCheckpointDetailQuery = gql`
  query getPendingCheckpointDetail($ids: [String!]!, $page: Int, $pageSize: Int) {
    getPendingCheckpointDetail(ids: $ids, page: $page, pageSize: $pageSize) {
      response
      totalCount
    }
  }
`;

export const getAppUserDetailQuery = gql`
  query getAppUserDetail($page: Int, $pageSize: Int) {
    getAppUserDetail(page: $page, pageSize: $pageSize) {
      response
      totalCount
    }
  }
`;

export const getActiveUserDetailQuery = gql`
  query getActiveUserDetail($page: Int, $pageSize: Int) {
    getActiveUserDetail(page: $page, pageSize: $pageSize) {
      response
      totalCount
    }
  }
`;